<!--==================================
=            SLIDERGROUPS            =
===================================-->
<template>
  <!-- WIDGETS CARDS -->
  <v-container >
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Slide Groups</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Playground

          </div>
          <div slot="card-body">
            <div>
              <v-row justify="space-around">
                <v-switch v-model="multiple" label="Multiple"></v-switch>
                <v-switch v-model="mandatory" label="Mandatory"></v-switch>
                <v-switch v-model="showArrows" label="Show arrows"></v-switch>
                <v-switch v-model="prevIcon" label="Custom prev icon"></v-switch>
                <v-switch v-model="nextIcon" label="Custom next icon"></v-switch>
                <v-switch v-model="centerActive" label="Center active item"></v-switch>
              </v-row>

              <v-sheet class="mx-auto" elevation="8" max-width="800">
                <v-slide-group v-model="model" class="pa-4" :prev-icon="prevIcon ? 'mdi-minus' : undefined"
                  :next-icon="nextIcon ? 'mdi-plus' : undefined" :multiple="multiple" :mandatory="mandatory"
                  :show-arrows="showArrows" :center-active="centerActive">
                  <v-slide-item v-for="n in 15" :key="n" v-slot:default="{ active, toggle }">
                    <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-4" height="200" width="100"
                      @click="toggle">
                      <v-row class="fill-height" align="center" justify="center">
                        <v-scale-transition>
                          <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'">
                          </v-icon>
                        </v-scale-transition>
                      </v-row>
                    </v-card>
                  </v-slide-item>
                </v-slide-group>
              </v-sheet>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Custom icons

          </div>
          <div slot="card-body">
            <v-sheet class="mx-auto" elevation="8" max-width="800">
              <v-slide-group v-model="model" class="pa-4" prev-icon="mdi-minus" next-icon="mdi-plus" show-arrows>
                <v-slide-item v-for="n in 15" :key="n" v-slot:default="{ active, toggle }">
                  <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-4" height="200" width="100"
                    @click="toggle">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-scale-transition>
                        <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'">
                        </v-icon>
                      </v-scale-transition>
                    </v-row>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Active class

          </div>
          <div slot="card-body">
            <v-sheet class="mx-auto" elevation="8" max-width="800">
              <v-slide-group v-model="model" class="pa-4" active-class="success" show-arrows>
                <v-slide-item v-for="n in 15" :key="n" v-slot:default="{ active, toggle }">
                  <v-card :color="active ? undefined : 'grey lighten-1'" class="ma-4" height="200" width="100"
                    @click="toggle">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-scale-transition>
                        <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'">
                        </v-icon>
                      </v-scale-transition>
                    </v-row>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Multiple

          </div>
          <div slot="card-body">
            <v-sheet class="mx-auto" elevation="8" max-width="800">
              <v-slide-group v-model="model" class="pa-4" multiple show-arrows>
                <v-slide-item v-for="n in 15" :key="n" v-slot:default="{ active, toggle }">
                  <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-4" height="200" width="100"
                    @click="toggle">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-scale-transition>
                        <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'">
                        </v-icon>
                      </v-scale-transition>
                    </v-row>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Mandatory

          </div>
          <div slot="card-body">
            <v-sheet class="mx-auto" elevation="8" max-width="800">
              <v-slide-group v-model="model" class="pa-4" mandatory show-arrows>
                <v-slide-item v-for="n in 15" :key="n" v-slot:default="{ active, toggle }">
                  <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-4" height="200" width="100"
                    @click="toggle">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-scale-transition>
                        <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'">
                        </v-icon>
                      </v-scale-transition>
                    </v-row>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Pseudo Carousel

          </div>
          <div slot="card-body">
            <v-sheet class="mx-auto" elevation="8" max-width="800">
              <v-slide-group v-model="model" class="pa-4" show-arrows>
                <v-slide-item v-for="n in 15" :key="n" v-slot:default="{ active, toggle }">
                  <v-card :color="active ? 'primary' : 'grey lighten-1'" class="ma-4" height="200" width="100"
                    @click="toggle">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-scale-transition>
                        <v-icon v-if="active" color="white" size="48" v-text="'mdi-close-circle-outline'">
                        </v-icon>
                      </v-scale-transition>
                    </v-row>
                  </v-card>
                </v-slide-item>
              </v-slide-group>

              <v-expand-transition>
                <v-sheet v-if="model != null" color="grey lighten-4" height="200" tile>
                  <v-row class="fill-height" align="center" justify="center">
                    <h3 class="title">Selected {{ model }}</h3>
                  </v-row>
                </v-sheet>
              </v-expand-transition>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Centered active item

          </div>
          <div slot="card-body">
            <v-sheet class="mx-auto" max-width="700">
              <v-slide-group multiple show-arrows>
                <v-slide-item v-for="n in 25" :key="n" v-slot:default="{ active, toggle }">
                  <v-btn class="mx-2" :input-value="active" active-class="purple white--text" depressed rounded
                    @click="toggle">
                    Options {{ n }}
                  </v-btn>
                </v-slide-item>
              </v-slide-group>
            </v-sheet>
          </div>
        </base-card>
      </v-col>
    </v-row>

  </v-container>

</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
  export default {
    components: {
      BaseCard,BaseHeader
    },
    data: () => ({
      model: null,
      multiple: false,
      mandatory: false,
      showArrows: true,
      prevIcon: false,
      nextIcon: false,
      centerActive: false,
    }),
  };
</script>


<!--====  End of SLIDERGROUPS  ====-->
